import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import style from './style';
import closeIcon from '../../assets/icons/close.svg';

const GlobalMessage = props => {
  const {
    classes,
    children,
    isSuccess,
    isWarning,
    dismissAction,
    showMsg
  } = props;

  const [showMessage, setShowMessage] = useState(showMsg);

  useEffect(() => {
    setTimeout(() => {
      setShowMessage('none');
    }, 5000);
  });

  return (
    <div
      className={`${classes.base} ${isSuccess ? classes.success : ''} ${
        isWarning ? classes.warning : ''
      }`}
      style={{ display: `${showMessage}` }}
    >
      <span>{children}</span>
      <img
        onClick={
          dismissAction ? () => dismissAction() : () => setShowMessage('none')
        }
        src={closeIcon}
        alt="close"
      />
    </div>
  );
};

const styleAndTheme = () => style;

GlobalMessage.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.object,
  isSuccess: PropTypes.bool,
  isWarning: PropTypes.bool,
  dismissAction: PropTypes.func
};

export default injectSheet(styleAndTheme)(GlobalMessage);
